<template>
    <div class="admin-colors">
        <h2>Gestion des couleurs</h2>
        <input v-model="search" class="styledInput" placeholder="Rechercher..." type="text">

        <div class="colors-container">
            <div
                v-for="color of getSortedColors()"
                :key="color._id"
                class="item"
                @click="selected = color; modal = 'color'; products = []; getProductsByColor();">
                <div :style="{backgroundColor: color.color}"></div>
                <p>{{ color.colorName }}</p>
            </div>
        </div>

        <Popup
            v-if="selected !== null"
            :title="`Color ${selected._id}`"
            :opened="modal == 'color'"
            @close="modal = ''">
            <div class="styledForm">
                <div class="form">
                    <input placeholder="Name" v-model="selected.colorName" class="styledInput">
                    <input type="color" v-model="selected.color">
                    <button @click="changeColor()" class="green-btn">Save</button>
                </div>
            </div>
            <h2>Products having {{ selected.colorName }}</h2>
            <div class="products">
                <router-link
                    target="_blank"
                    :to="{ name: 'admin_products_variant', params: { id: v._id }}"
                    v-for="v in products"
                    :key="v._id"
                    class="item">
                    <img class="adm-img" v-lazy="imgURL+'/'+v.mainPicture" alt="main picture">
                </router-link>
            </div>
            <div class="styledForm">
                <div class="form">
                    <h3>Fusion two colors (this one will be removed)</h3>
                    <div class="custom-input">
                        <input type="text" placeholder="Color id" v-model="fusionid">
                        <button @click="fusion()" class="green-btn">Fusion</button>
                    </div>
                </div>
            </div>
            <button class="remove" @click="deleteSelectedColor">Delete Color</button>
        </Popup>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Popup from "../../../components/Popup";

    export default {
        name: "AdminProductColor",
        components: {Popup},
        created() {
            this.getColors()
        },
        data() {
            return {
                search: '',
                modal: '',
                selected: null,
                products: [],
                imgURL: "http://163.172.150.46:3000/img",
                fusionid: '',
            }
        },
        computed: {
            ...mapGetters('product', [
                'colors',
            ])
        },
        methods: {
            ...mapActions('product', [
                'getColors',
                'deleteColor',
                'getColorProducts',
                'updateColor',
                'mergeColors',
            ]),
            getSortedColors() {
                if (this.search === "") return this.colors;
                return this.colors.filter(c => c.colorName.toLowerCase().indexOf(this.search.toLowerCase()) != -1);
            },
            getProductsByColor() {
                this.getColorProducts(this.selected._id).then(data => {
                    this.products = data.products;
                });
            },
            deleteSelectedColor() {
                if (!confirm("Are you sure to want to delete this color ?")) return;
                this.deleteColor(this.selected._id).then(() => {
                    this.selected = null;
                    this.products = [];
                });
            },
            changeColor() {
                this.updateColor(this.selected).then(() => {
                    this.selected = null;
                });
            },
            fusion() {
                if (this.selected._id === this.fusionid) return;
                this.mergeColors({from: this.selected._id, to: this.fusionid}).then(() => {
                    this.selected = null;
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .admin-colors {
        padding-left: 30px;
    }

    .colors-container{
        display: flex;
        flex-wrap: wrap;

        .item{
            display: flex;
            align-items: center;
            background-color: var(--main-green);
            border-radius: 3px;
            color: #fff;
            padding: 8px 10px;
            width: fit-content;
            margin: 0 10px 10px 0;
            cursor: pointer;

            div{
                height: 16px;
                width: 16px;
                background-color: #fff;
                border: 1px solid #000;
                margin-right: 10px;
            }

            p{
                margin: 0;
            }
        }
    }
    .products {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        margin-bottom: 30px;
        max-height: 300px;
        overflow-y: scroll;

        > a {
            height: 120px;
            width: 80px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin: 0 10px;

            img {
                height: 100%;
            }
        }
    }
    .remove {
        border: 0;
        padding: 10px 25px;
        background-color: #f44336;
        color: #fff;
        font-weight: bold;
        border-radius: 3px;
        cursor: pointer;
    }
    .styledForm {
        .form {
            .green-btn {
                display: block;
                margin-top: 20px;
                border-radius: 2px;
                padding: 10px 25px;
            }
            .custom-input {
                display: flex;
                input {
                    flex: 1;
                    padding: 10px;
                    border: 1px solid #000;
                    border-radius: 5px 0 0 5px;
                }
                button {
                    background-color: var(--main-green);
                    color: #fff;
                    border: 0;
                    font-size: 20px;
                    border-radius: 0 5px 5px 0;
                    cursor: pointer;
                    margin: 0;
                }
            }
        }
    }
</style>
